
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/talent-engine/save",
      function () {
        return require("private-next-pages/talent-engine/save/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/talent-engine/save"])
      });
    }
  